import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { AppContext } from '../../AppProvider';
import Barcode from 'react-barcode';
import Grid from '@material-ui/core/Grid';
import combineStyles from '../../utils/combineStyles';
import { withStyles } from '@material-ui/core/styles';
import { withNamespaces } from 'react-i18next';
import TypographyStyles from '../../styles/typography';
import LayoutStyles from '../../styles/layout';
import SpacingStyles from '../../styles/helpers/spacing';
import BOLStyles from './__styles__/BOL.styles';
import FormItemContainerStyles from '../../components/Global/Containers/__styles__/FormItemContainer.styles';

class Header extends Component {
  static propTypes = {
    shipment: PropTypes.object.isRequired
  };

  render() {
    const { classes, t, shipment } = this.props;
    const rate = shipment.selectedShipmentRate;
    const proNumText = `${t('PRO')}# ${shipment.proNumber}`;

    return (
      <Grid container spacing={8} className={classes.headerMargin}>
        <Grid item xs={2}>
          <p
            className={classnames(
              classes.headline4,
              classes.title,
              classes.boldWeight,
              classes.textMargin
            )}
          >
            {t('BOL')}
          </p>
          <p className={classes.textMargin}># {shipment.bolNumber}</p>
        </Grid>
        <Grid
          item
          xs={6}
          className={shipment.proNumber ? '' : classes.proBorder}
        >
          {shipment.proNumber && (
            <Barcode value={shipment.proNumber} text={proNumText} height={40} />
          )}
          {!shipment.proNumber && <p>{t('PRO Number Label')}</p>}
        </Grid>
        <Grid item xs={2} />
        <Grid item xs={2} className={classes.boxBackground}>
          <p>
            {(!rate || !rate.carrier) && <span>{t('Carrier')}: </span>}
            <span className={classes.headline6}>
              {(!rate || !rate.carrier) && <span>--</span>}
              {rate && rate.carrier && rate.carrier.logoUrl && (
                <img
                  src={rate.carrier.logoUrl}
                  alt={rate.carrier.name}
                  className={classes.carrierLogo}
                />
              )}
              {rate && rate.carrier && !rate.carrier.logoUrl && (
                <span>{rate.carrier.name}</span>
              )}
            </span>
          </p>
        </Grid>
      </Grid>
    );
  }
}

Header.contextType = AppContext;
const translatedHeader = withNamespaces()(Header);
export default withStyles(
  combineStyles(
    BOLStyles,
    FormItemContainerStyles,
    TypographyStyles,
    LayoutStyles,
    SpacingStyles
  )
)(translatedHeader);
